import React, { forwardRef, useEffect, useMemo, useRef, useState } from 'react'
import { AnimatePresence, motion, useAnimation, useInView } from 'framer-motion'

const HowItWorks = forwardRef(({ inViewRef }, scrollRef) => {

    const ref = useRef(null)
    const controls = useAnimation()
    const isInView = useInView(ref, {
        margin: '0px 0px -150px 0px',
        once: true
    })

    const [ showMiddle, setShowMiddle ] = useState(false)
    const [ revealed, setRevealed ] = useState(-1)
    const [ showCircle, setShowCircle ] = useState(false)

    const benefits = useMemo(() => {
        return [
            {
                id: 0,
                content:<div className='flex items-center gap-2'>
                    <div className="w-fit bg-[#091F36] p-2">
                        <img
                            src="https://assets.learntube.ai/files/New%20Landing%20Page/thumbsup.svg?updatedAt=1744185899171"
                            width={21}
                            height={21}
                            alt=""
                            className="mx-auto"
                        />
                        <div className="leading-[130%] mt-2 text-[10px]">
                            <p>Gain</p>
                            <p>Recognition</p>
                        </div>
                    </div>
                    <img
                        src="https://assets.learntube.ai/files/New%20Landing%20Page/down-arrow.svg?updatedAt=1744184923146"
                        width={12}
                        height={14}
                        className="rotate-90"
                        alt=""
                    />
                </div>
            },
            {
                id: 1,
                content:<div className='flex flex-col items-center gap-2'>
                    <img
                        src="https://assets.learntube.ai/files/New%20Landing%20Page/down-arrow.svg?updatedAt=1744184923146"
                        width={12}
                        height={14}
                        className="rotate-[30deg] -mr-2"
                        alt=""
                    />
                    <div className="w-fit bg-[#091F36] p-2">
                        <img
                            src="https://assets.learntube.ai/files/New%20Landing%20Page/job-chance.svg?updatedAt=1744186634910"
                            width={18}
                            height={21}
                            alt=""
                            className='mx-auto'
                        />
                        <div className="leading-[130%] mt-2 text-[10px]">
                            <p><span className="text-white font-bold">3x</span> your Job</p>
                            <p>Chances</p>
                        </div>
                    </div>
                </div>
            },
            {
                id: 2,
                content:<div className='flex flex-col items-center gap-2'>
                    <img
                        src="https://assets.learntube.ai/files/New%20Landing%20Page/down-arrow.svg?updatedAt=1744184923146"
                        width={12}
                        height={14}
                        className="-rotate-[30deg] -ml-4"
                        alt=""
                    />
                    <div className="w-fit bg-[#091F36] p-2">
                        <img
                            src="https://assets.learntube.ai/files/New%20Landing%20Page/Group_3.svg?updatedAt=1744186835820"
                            width={21}
                            height={21}
                            alt=""
                            className='mx-auto'
                        />
                        <div className="leading-[130%] mt-2 text-[10px]">
                            <p>Get Noticed by</p>
                            <p>Employers</p>
                        </div>
                    </div>
                </div>
            },
            {
                id: 3,
                content:<div className='flex items-center gap-2'>
                    <img
                        src="https://assets.learntube.ai/files/New%20Landing%20Page/down-arrow.svg?updatedAt=1744184923146"
                        width={12}
                        height={14}
                        className="-rotate-90"
                        alt=""
                    />
                    <div className={`w-fit bg-[#091F36] p-2`}>
                        <img
                            src="https://assets.learntube.ai/files/New%20Landing%20Page/increase-salary.svg?updatedAt=1744179161219"
                            width={16}
                            height={21}
                            alt=""
                            className="mx-auto"
                        />
                        <div className="leading-[130%] mt-2 text-[10px]">
                            <p>Increase Salary</p>
                            <p className="text-white font-bold">up to 150%</p>
                        </div>
                    </div>
                </div>
            },
        ]
    }, [])

    useEffect(() => {
        if (isInView) {
            setShowMiddle(true)
            const revealSteps = async () => {
                for (let i = 0; i <= benefits.length; i++) {
                    await new Promise((res) => setTimeout(res, 600))
                    setRevealed(i)
                }
                await new Promise((res) => setTimeout(res, 600))
                setShowCircle(true)
            }
            revealSteps()
        }
    }, [benefits.length, isInView])

    useEffect(() => {
        const sequence = async () => {
            await controls.start({
                opacity: 1,
                scale: 1,
                transition: { duration: 1 },
            })
            controls.start({
                rotate: -360,
                transition: {
                repeat: Infinity,
                duration: 12,
                ease: "linear",
                },
            })
        }

        sequence()
    }, [controls, showCircle])

    useEffect(() => {
        if (scrollRef && typeof scrollRef === 'object') {
            scrollRef.current = ref.current
        }
    }, [scrollRef])
    
    return (
        <div ref={ref} className='text-xxs -ml-4 w-[calc(100%+2rem)] text-[#83BEFF] pb-[80px]'
        >
            <div ref={inViewRef} className='mt-4 relative text-center'>
                <AnimatePresence>
                    {showMiddle && (<>
                        <motion.div 
                            className="flex flex-col items-center relative"
                            initial={{ opacity: 0, scale: 0.8 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.3 }}
                        >
                            <div className="w-[92px] h-[92px] bg-[#0E4771] border-[4px] border-[#006FBC]/20 rounded-full flex flex-col items-center justify-center px-2 relative z-20 text-[10px]">
                                <img src="https://assets.learntube.ai/files/New%20Landing%20Page/Quiz%201.svg?updatedAt=1744179014975" width={21} height={21} alt=""/>
                                <p>Pass a Quick</p>
                                <p>Test</p>
                            </div>
                            <img
                                src="https://assets.learntube.ai/files/New%20Landing%20Page/down-arrow.svg?updatedAt=1744184923146"
                                width={12}
                                height={14}
                                className="-mt-1 relative z-20"
                                alt=""
                            />
                        </motion.div>
                        <motion.div
                            className="w-fit mx-auto flex flex-col items-center justify-center relative"
                            initial={{ opacity: 0, scale: 0.8 }}
                            animate={{ opacity: 1, scale: 1 }}
                            exit={{ opacity: 0 }}
                            transition={{ duration: 0.3 }}
                        >
                            <div className="w-[110px] h-[110px] px-1 bg-[#08578F] border-[6px] border-[#006FBC]/20 rounded-full flex flex-col items-center justify-center relative z-20 text-[10px]">
                                <img
                                    src="https://assets.learntube.ai/files/New%20Landing%20Page/Certificate%201.svg?updatedAt=1744181188447"
                                    width={22}
                                    height={21}
                                    alt=""
                                />
                                <p className="mt-2">Unlock Instant</p>
                                <p>Certificate</p>
                            </div>
                            {showCircle && <div className='w-[203px] h-[203px] absolute z-0 left-1/2 -translate-x-1/2 '>
                                <motion.img 
                                    src="https://assets.learntube.ai/files/New%20Landing%20Page/Group%2022973.png?updatedAt=1744727963291" 
                                    className="w-full h-full" 
                                    alt=""
                                    initial={{ opacity: 0, scale: 0.8}}
                                    animate={controls}
                                />
                            </div>}
                            {showCircle && <div className='w-[243px]  h-[243px] absolute left-1/2 -translate-x-1/2 z-0'>
                                <motion.img 
                                    src="https://assets.learntube.ai/files/New%20Landing%20Page/bigger-circle.png?updatedAt=1744727963586" 
                                    className="w-full h-full" 
                                    alt=""
                                    initial={{ opacity: 0, scale: 0.8}}
                                    animate={controls}
                                />
                            </div>}
                            {showCircle && <div className='w-[243px] h-[243px] absolute left-1/2 -translate-x-1/2 z-10 rounded-full' />}
                            {benefits?.map((benefit, index) => {
                                const positions = [
                                    '-left-[94px] top-5',
                                    '-left-[30px] top-[95px]',
                                    '-right-[38px] top-[95px]',
                                    '-right-[110px] top-5',
                                ]
                                return (<AnimatePresence key={index}>
                                    {revealed >= benefit.id && (<motion.div
                                        initial={{ opacity: 0, scale: 0.5 }}
                                        animate={{ opacity: 1, scale: 1 }}
                                        exit={{ opacity: 0 }}
                                        transition={{ duration: 0.3 }}
                                        className={`absolute z-20 ${positions[index]}`}
                                    >
                                        {benefit?.content}
                                    </motion.div>)}
                                </AnimatePresence>)
                            })}
                        </motion.div>
                    </>)}
                </AnimatePresence>
                
            </div>
        </div>
    )
})

export default HowItWorks